module.exports = ".mat-dialog-container {\n     overflow: inherit !important;\n}\n\n::ng-deep .custom-tooltip {\n\tfont-size: 14px;\n\tbackground: #6ee229;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/customer-enroll/customer-enroll-wizard/customer-enroll-wizard.component.css
// module id = ./src/app/customer-enroll/customer-enroll-wizard/customer-enroll-wizard.component.css
// module chunks = main